/**
 * Suppliers
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageSuppliersComponent,
  AsyncAddSupplierComponent,
  AsyncModifySupplierComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageSuppliersComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddSupplierComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifySupplierComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
